module.exports = __webpack_public_path__ + "img/corporate-buildings-m.66678c7e.png";